import { io } from "socket.io-client";

const socketUrl =
  process.env.REACT_APP_WS_URL ||
  (window.location.hostname === "velvour.vnoirs.com"
    ? "wss://multi.vnoirs.com"
    : "ws://localhost:5500");

const socket = io(socketUrl, {
  transports: ["websocket", "polling"],
  withCredentials: true,
  autoConnect: false, // 🔥 IMPORTANT
});

export default socket;
